import React from 'react';
import { Box, Paper, Skeleton, CircularProgress, Typography } from '@mui/material';

const DetailLoadingState = ({ title = 'Загружаем данные...' }) => {
  return (
    <Box sx={{ width: '100%', py: 2 }}>
      <Paper
        sx={{
          p: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
          <CircularProgress size={22} thickness={5} />
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>

        <Skeleton variant="rounded" height={44} sx={{ mb: 1.5 }} />
        <Skeleton variant="rounded" height={44} sx={{ mb: 1.5 }} />
        <Skeleton variant="rounded" height={120} sx={{ mb: 1.5 }} />
        <Skeleton variant="rounded" height={44} sx={{ mb: 1.5 }} />
        <Skeleton variant="rounded" height={44} width="35%" />
      </Paper>
    </Box>
  );
};

export default DetailLoadingState;
